import { h } from 'preact';

export const arrowRight = (
  <svg xmlns="http://www.w3.org/2000/svg" width="23.999" height="10" viewBox="0 0 23.999 10">
    <path
      id="Union_26"
      data-name="Union 26"
      d="M-6020-2h4V-20h2V-2h4l-5,6Z"
      transform="translate(20 -6010) rotate(-90)"
    />
  </svg>
);

export default {
  arrowRight,
};
